import Vue from "vue";
import Vuetify from "vuetify/lib";
import "vuetify/src/stylus/app.styl";
import "../theme/default.styl";

Vue.use(Vuetify, {
    theme: {
        primary: "#0779FF",
        secondary: "#424242",
        dark: "#212E3C",
        accent: "#82B1FF",
        error: "#FF5E44",
        info: "#2196F3",
        success: "#4CAF50",
        warning: "#FFC107"
    },
    customProperties: true,
    iconfont: "md"
});
